import { NgModule } from '@angular/core';
import { AbcInputComponent } from './abcInput.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  declarations: [AbcInputComponent],
  exports: [AbcInputComponent, MatInputModule],
})
export class AbcInputModule {
  constructor() {}
}
